<template lang="pug">
q-card.modal-form-card
  q-form(@submit="submitForm")
    q-card-section
      form-header(
        ref="formHeaderRef",
        :parentData="{ title: t('title'), title_icon: 'show_header.svg' }",
        @close-form="closeForm"
      )

    q-card-section
      checkbox(v-model="hideEmptyFields", :label="t('hideEmptyFields')")
      checkbox(v-model="printImages", :label="t('printImages')")

    q-card-actions.button-group.row.justify-center
      q-btn.modal-form-cancel(flat, no-caps, :label="t('cancel')", @click="closeForm")
      q-btn.modal-form-submit(flat, no-caps, type="submit", :label="t('submit')")
</template>

<script setup>
import { ref, onMounted } from "vue";
import i18n from "@/plugins/vue-i18n";
import { currentLocale } from "@/services/useLocales";
import formHeader from "./formHeader.vue";
import Checkbox from "../general_components/inputs/Checkbox.vue";

const emit = defineEmits(["close", "submit"]);
const formHeaderRef = ref(null);
const hideEmptyFields = ref(true);
const printImages = ref(false);

const t = key => i18n.t(`issuePrint.${key}`, currentLocale.value);
const closeForm = () => emit("close");
const submitForm = () => emit("submit", { hideEmptyFields: hideEmptyFields.value, printImages: printImages.value });

onMounted(() => formHeaderRef.value.setLoading(false));
</script>

<style lang="scss">
@import "../../../assets/styles/forms/modal-form.scss";
</style>
